import React from "react";
import { Loader } from "semantic-ui-react";
import { useSubscriptionStatus } from "../../hooks/useSubscriptionStatus";
import SubscriptionRestriction from "./subscriptionRestriction/SubscriptionRestriction";

/**
 * Hides feature content when the company subscription is not usable (same rules as settings / leave).
 * @param {{ children: React.ReactNode, actionKey?: string }} props
 */
const SubscriptionRestrictedFeature = ({
    children,
    actionKey = "app.subscriptionRestriction.actionPerformAction",
}) => {
    const { isSuspended, loading } = useSubscriptionStatus();

    if (loading) {
        return (
            <div style={{ padding: "40px", textAlign: "center" }}>
                <Loader active inline="centered" size="large" />
            </div>
        );
    }

    if (isSuspended) {
        return (
            <div style={{ padding: "20px" }}>
                <SubscriptionRestriction actionKey={actionKey} />
            </div>
        );
    }

    return <>{children}</>;
};

export default SubscriptionRestrictedFeature;
